import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CdsLanguageModule } from '@cds/ng-core/lang';
import { CdsIconModule } from '@cds/ng-web-components/icon';
import { NoResultFoundComponent } from './no-result-found.component';
@NgModule({
  imports: [CommonModule, CdsIconModule, CdsLanguageModule, NoResultFoundComponent],
  exports: [NoResultFoundComponent],
})
export class NoResultFoundModule {}
